import React from 'react';
import { NavLink } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Base from './Base';

class DocumentComment extends Base {
  constructor(props) {
    super(props);
    let inline = 0;
    if (!this.isNull(this.props.inline)){
      if(this.props.inline == 1) inline = 1;
    }

    this.state.form = {
      requestId: (inline === 0 ? this.props.params.request_id : this.props.request_id),
      hash: (inline === 0 ? this.props.params.hash : this.props.hash),
      name:'',
      score:5,
      comment:''
    }
    this.state.inline = inline;
    this.state.submit = false;
  }
  setForm(e, field) {
    this.state.form[field] = e.target.value;
  }
  submit(e) {
    e.preventDefault();
    this.lockScreen();
    this.httpPost("/ajax/send_comment/", {
      form: this.state.form
    })
    .then(dataHolder => {
      this.unLockScreen();
      if (dataHolder.status === 0) {
        this.setState({ submit: false });
        this.showErrorToast(dataHolder.message);
      }
      else
      {
        this.showSuccessToast("نظر شما با موفقیت ثبت گردید");
        this.setState({ submit: true });
      }
    }).catch(err=>{      
      this.unLockScreen();
      this.showErrorToast("سامانه قادر به اجرای درخواست شما نیست");
    });
  }
  getDocumentTypeCaption(document_sub_type){
    if (document_sub_type === 1 || document_sub_type === 2) return 'مقاله';
    if (document_sub_type === 3) return 'کتاب';
    if (document_sub_type === 4) return 'طرح پژوهشی';
    if (document_sub_type === 5) return 'سند پژوهشی';
    if (document_sub_type === 9) return 'مقاله پیش چاپ';
  }
  componentDidMount() {
    if (this.state.dataHolder !== null && this.state.inline !== 1) return;
    //let { request_id,hash } = this.props.params;
    //if (this.state.request_id === request_id && this.state.hash === hash) return;
    //this.state.form.request_id=request_id;
    //this.state.form.hash=hash;
    this.httpPost('/doc/comment/send/' + this.state.form.requestId + '/' + this.state.form.hash + '/')
    .then((dataHolder) => {
      this.setState({ dataHolder });
    })
    .catch((error) => {
      this.showErrorToast(this.MC(1));
      this.setState({ dataHolder: { status: 0 } });
    });
  }
  renderForm(){
    return (<div className={this.state.inline === 1 ? "" : 'px-4'}>
              {this.state.inline !== 1 &&
                <div className={'text-color-muted dark:text-color-muted-dark leading-7 my-4'}>
                  پژوهشگر و فرهیخته گرامی؛ {this.state.dataHolder.currentPerson !== null ?
                  this.state.dataHolder.currentPerson.fname + " " + this.state.dataHolder.currentPerson.lname
                  :
                  this.state.dataHolder.request.UserEMail
                  }<br/>
                از اینکه نظر تخصصی خود در مورد {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)} <NavLink to={"/doc/" + this.state.dataHolder.paper.id + "/"}><strong>"{this.state.dataHolder.paper.title}"</strong></NavLink> (شناسه ملی {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)}: {this.state.dataHolder.paper.coi})  را در اختیار سایر پژوهشگران می گذارید بسیار متشکریم. اشتراک نظرات فنی و تخصصی شما مطمئنا راهگشای استفاده سایر پژوهشگران خواهد بود.
                  <br/>
                  در پایگاه سیویلیکا فقط پژوهشگرانی می توانند در خصوص {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)} اعلام نظر نمایند که آن را دانلود نموده باشد. شما این {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)} را در تاریخ {this.g2j(this.state.dataHolder.request.AddDate)} دانلود فرموده اید.  
                </div>
              }
              {this.state.dataHolder.request.mode === 1 &&
                <div className="text-color-muted dark:text-color-muted-dark leading-7 my-4">
                  <b>عضو محترم، پس از تایید نظر شما، یک پنجم اعتبار کسر شده به حساب کاربری شما برگردانده می شود. یعنی با هر ۵ نظری که اعلام می فرمایید، یک {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)} رایگان می توانید دانلود فرمایید.</b>
                </div>
              }
              {this.state.dataHolder.status === 5 ? 
                <div className='max-w-6xl bg-red-100 text-red-500 rounded p-3 mx-auto text-center mt-4 leading-7'>
                  نظرات شما به این {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)} قبلا ثبت شده است
                </div>
              :
                this.state.submit === false ?
                  <form className={'max-w-6xl mx-auto'}>
                    {this.state.inline !== 1 &&
                      <label className={'flex flex-col space-y-2'}>
                        <span className={'text-color-base dark:text-color-base-dark font-medium'}>نام و نام خانوادگی </span>
                        {this.state.dataHolder.currentPerson !== null ?
                          this.state.dataHolder.currentPerson.fname + " " + this.state.dataHolder.currentPerson.lname
                        :
                          <input
                            type="text"
                            onChange={e=>this.setForm(e,'name')}
                            defaultValue={this.state.form.name}
                            className={'border-gray-200 rounded dark:bg-light-700 dark:text-color-base-dark text-color-base dark:border-light-600'}
                            placeholder={'نام و نام خانوادگی '}
                          />
                        }
                      </label>
                    }
                    <label className={'flex flex-col space-y-2'}>
                      <span className={'text-color-base dark:text-color-base-dark font-medium'}>از یک تا پنج برای این {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)} چه امتیازی می دهید؟</span>
                      <select onChange={e=>this.setForm(e,'score')} defaultValue={this.state.form.score} 
                        className={'border-gray-200 rounded dark:bg-light-700 dark:text-color-base-dark text-color-base dark:border-light-600'}>
                        <option value="1">خیلی بد</option>
                        <option value="2">ضعیف</option>
                        <option value="3">متوسط</option>
                        <option value="4">خوب</option>
                        <option value="5">عالی</option>
                      </select>
                    </label>
                    <label className={'flex flex-col space-y-2'}>
                      <span className={'text-color-base dark:text-color-base-dark font-medium'}>اگر توضیح تخصصی و فنی در خصوص محتوای علمی این {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)} دارید لطفا یادداشت فرمایید: (غیر اجباری)</span>
                      <textarea
                        type="text"
                        onChange={e=>this.setForm(e,'comment')} 
                        rows="7" 
                        defaultValue={this.state.form.comment}
                        className={'border-gray-200 rounded dark:bg-light-700 dark:text-color-base-dark text-color-base dark:border-light-600'}
                        placeholder={"فقط نظر تخصصی در مورد این " + this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type) + " وارد شود و از درج سایر موارد یا پیام به سیویلیکا خودداری فرمایید. این متن به صورت عمومی به عنوان یادداشت تخصصی و نقد شما در مورد این " + this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type) + " برای سایر پژوهشگران نمایش داده خواهد شد."}
                      ></textarea>
                    </label>
                    <div className={'flex my-4 justify-center'}>
                      <button onClick={e=>this.submit(e)} type="submit" className={'bg-brand hover:bg-brand/90 btn dark:bg-brand-dark dark:hover:bg-brand-dark/90 px-4 py-3 rounded text-white'}>
                      ثبت نظر و امتیاز شما
                      </button>
                    </div>
                  </form>
                :
                  <div>
                    <div className={'text-color-muted dark:text-color-muted-dark leading-7 my-4'}>
                    نظرات شما با موفقیت ثبت شد و بعد از تایید مدیریت بر روی سایت نمایش داده خواهد شد.
                    </div>
                  </div>
              }
              {this.state.inline !== 1 && !this.isBlank(this.state.dataHolder.paper.abstract) &&
                <div className="text-color-muted dark:text-color-muted-dark leading-7 my-4">
                  <h2>چکیده {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)}:</h2>
                  <div className="item j" dangerouslySetInnerHTML={{__html: this.state.dataHolder.paper.abstract}}></div>
                </div>
              }
            </div>);
  }
  render() {
    if (!this.isBlank(this.state.redirectTo)) return this.redirectTo();
    
    var html = [this.renderToast()];

    if (this.isNull(this.state.dataHolder)) {
      html.push(this.renderPlaceHolder());
    } else {
      if (this.state.dataHolder.status === 0) {
        if (this.state.inline !== 1) html.push(this.renderErorrInLoading());
      }
      if (this.state.dataHolder.status === 404) {
        if (this.state.inline !== 1) html.push(this.render404());
      }
      if (this.state.dataHolder.status === 500) {
        if (this.state.inline !== 1) html.push(this.render500());
      }
      if (this.state.dataHolder.status === 1) {
        if (this.state.inline !== 1) html.push(this.renderHeader());
        if (this.state.inline !== 1) html.push(this.setMetaTags());
        if (this.state.inline === 1){
          html.push(this.renderForm());
        }
        else{
          html.push(
            <section className="grid grid-cols-12 gap-4 container mx-auto my-4 px-4">
              <article className="col-span-12 xl:col-span-9 ">
                <div className='border shadow-me rounded'>
                  <header className='flex flex-col justify-between px-4 pt-4'>
                    <h3 className="font-bold h_title mb-2 border-b pb-2">فرم ثبت نظر پژوهشگران برای {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)}</h3>
                  </header>
                  {this.renderForm()}
                </div>
              </article>
              <aside className={'col-span-12 xl:col-span-3 '}>
                <div className={' space-y-4'}>
                  <div className={'max-w-6xl bg-red-100 text-red-500 rounded p-3 mx-auto text-center mt-4 leading-7'}>
                  خواهشمندیم توجه فرمایید...
                  </div>
                  <div className={'bg-yellow-100 text-yellow-600 rounded p-3 max-w-4xl mx-auto leading-7'}>
                    سیویلیکا یک پایگاه علمی و تخصصی است، لذا خواهشمندیم نظرات فنی و تخصصی خود را به دور از هر گونه مسائل حاشیه ای (مانند توهین، تمسخر، اتهام زنی و ... که خارج از چهارچوب بحث علمی است) اعلام فرمایید. همه نظرات علمی و تخصصی چه نظرات تاییدی و چه انتقادی بدون استثنا تایید و در صفحه {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)} نمایش داده خواهند شد ولی به منظور حفظ شان و جایگاه سایت، از انتشار نظرات حاشیه ای معذوریم.
                    <br/>
                    این بخش برای مباحث علمی و نقد محتوای تخصصی و دستآوردهای {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)} است، لذا در صورتی که به هنگام دانلود و استفاده از این {this.getDocumentTypeCaption(this.state.dataHolder.paper.document_sub_type)} مشکلاتی مانند عدم نمایش قلم، عدم نمایش تصاویر و ... پیش آمده است، آن را فقط از طریق 
                    <b> <NavLink to={"/support/inv/" + this.state.form.requestId + "/"}>بخش پشتیبانی</NavLink> </b>
                    به ما اطلاع دهید. مسئولیت رفع مشکل فایل بر عهده سیویلیکا می باشد.
                    <br/>
                  </div>
                </div>
              </aside>
            </section>
          );
        }
        if (this.state.inline !== 1) html.push(this.renderFooter());
      }
    }
    return html;
  }
}
var DocumentCommentExp = (props) => <DocumentComment {...props} params={useParams()} />;
export default DocumentCommentExp;
